import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Select, Input } from 'antd';
const Option = Select.Option;
const InputGroup = Input.Group;
import * as update from 'immutability-helper';
import StaticView from './StaticView';

export default class Certificate extends React.Component<any> {
    optionMap: any = {
        idCard: intl.get('Component.FormIdCard').d('身份证'),
        passport: intl.get('Component.FormPassport').d('护照'),
        other: intl.get('Component.FormOther').d('其他'),
    };
    /**
     * 值改变处理
     * @param {0 | 1} index
     * @returns {(data: string) => void}
     */
    changeHandler = (index: 0 | 1) => (data: string) => {
        const { value, onChange } = this.props;
        onChange(update((value || ['', '']), {
            [index]: { $set: data }
        }));
    };

    /**
     * 失焦处理
     */
    blurHandler = () => {
        let { value, onBlur } = this.props;
        // 赋值初始值为‘idCard'
        if (!value) value = ['idCard', ''];
        if (value && !value[0]) value[0] = 'idCard';
        if (onBlur) onBlur(value);
    };

    render() {
        const { placeholder, initialValue, disabled, staticView } = this.props;
        return (
            (staticView && disabled)
                ? <StaticView display={initialValue} adaptFn={(val: any) => (val && val[0]) ? `(${this.optionMap[val[0]]}) ${val[1]}` : '-'}/>
                : <InputGroup compact style={{ height: 32 }} className={staticView && disabled ? 'Form-static-view' : ''}>
                    <Select placeholder={placeholder[0]} defaultValue={(initialValue && initialValue[0]) || 'idCard'}
                            onChange={this.changeHandler(0)} style={{ width: "40%" }}
                            disabled={disabled}>
                        {Object.entries(this.optionMap).map(([key, value]: any) => <Option key={key}>{value}</Option>)}
                    </Select>
                    <Input placeholder={placeholder[1]} defaultValue={(initialValue && initialValue[1]) || ''}
                           onChange={(e: any) => this.changeHandler(1)(e.target.value)} onBlur={this.blurHandler}
                           style={{ width: "60%" }} disabled={disabled}/>
                </InputGroup>
        );
    }
}
